// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-components----Tiles-module---flex---3ceW7","header":"src-components----Tiles-module---header---3FZRS","animateText":"src-components----Tiles-module---animateText---338jR","grid":"src-components----Tiles-module---grid---kli2J","image":"src-components----Tiles-module---image---4JevU","tile":"src-components----Tiles-module---tile---1T6hM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tiles.module.css
// module id = 159
// module chunks = 89127590239909 230350374021974